const constants = {
  title: "ᬅᬓ᭄ᬱᬮᬶ",
  like: "ᬤᭂᬫᭂᬦ᭄,",
  search: "ᬧᬜ᭄ᬮᬶᬓ᭄ᬱᬶᬓᬦ᭄",
  welcomeback: "ᬲ᭄ᬯᬲ᭄ᬢᬶᬧ᭄ᬭᬧ᭄ᬢ",
  //route - navbar
  reportPost:"ᬮᬧᭀᬭᬂ",
  singlePost: "ᬧᭀᬲ᭄ᬢᬶᬗᬦ᭄",
  comments: "ᬓᭀᬫᭂᬦ᭄ᬢᬃ",
  posting:"ᬧᭀᬲ᭄ᬢᬶᬂ",
  profile:"ᬧ᭄ᬭᭀᬧᬶᬮ᭄",
  editPost:"ᬳᬾᬤᬶᬢ᭄ᬧᭀᬲ᭄ᬢᬶᬗᬦ᭄",
  deletePost:"ᬳᬧᬸᬲ᭄ᬧᭀᬲ᭄ᬢᬶᬗᬦ᭄",
  follower:"ᬧᭀᬮᭀᬯᭂᬃ",
  editPhoto:"ᬕᬦ᭄ᬢᬶᬧᭀᬢᭀ",
  term:"ᬲ᭄ᬬᬭᬢ᭄ᬮᬦ᭄ᬓᭂᬢᭂᬦ᭄ᬢᬸᬯᬦ᭄",
  resetPassword:"",
  //Posting
  status:"ᬲ᭄ᬢᬢᬸᬲ᭄",
  hint:"ᬧᬶᬢᬓᬾᬦ᭄",
  answer:"ᬧᬲᬳᬸᬃ",
  image:"ᬕᬫ᭄ᬩᬃ",
  placeholderText:"ᬦᬧᬶᬲᬦᬾᬓᬬᬸᬦᬶᬦ᭄",
  chooseImage:"ᬧᬶᬮᬶᬄᬕᬫ᭄ᬩᬃ",
  exampleHint:"ᬘᭀᬦ᭄ᬢᭀ:ᬳᬤᬦ᭄ᬩᬸᬭᭀᬦ᭄",
  //Post
  other:"ᬲᬦᬾᬮᬶᬬᬦᬦ᭄",
  conratulation:"ᬧᬢᬸᬢ᭄",
  //Login & Register
  login: "ᬮᭀᬚᬶᬦ᭄",
  register: "ᬤᬧ᭄ᬢᬃ",
  welcomeLogin: "ᬤᬸᬭᬸᬲᬂᬗᭂᬭᬜ᭄ᬚᬶᬂ᭟",
  welcomeRegister: "ᬤᬸᬭᬸᬲᬂᬤᬕᬶᬗᬶᬦ᭄ᬫᬓᬲᬫᬶ᭟",
  email: "ᬇᬫᬾᬮ᭄",
  name: "ᬧᭂᬲᬾᬗᬦ᭄",
  password: "ᬲᬦ᭄ᬤᬶ",
  repeatPassword: "ᬓᭂᬢᬶᬓ᭄ᬫᬮᬶᬄᬲᬦ᭄ᬤᬶ",
  createAccount: "ᬓᬃᬬᬦᬶᬦ᭄ᬳᬓᬸᬦ᭄",
  address: "ᬲᬓᬶᬂᬤᬶᬚ",
  textLogin: "ᬤᬸᬭᬸᬂᬫᬤᬸᬯᬾᬳᬓᬸᬦ᭄‌ᬤᬧ᭄ᬢᬃᬤᭂᬭᬶᬓᬶ",
  textReset: "ᬬᬾᬦᬶᬂᬮᬮᬶᬳᬦ᭄ᬢᬸᬓ᭄ᬲᬦ᭄ᬤᬶᬭᬕᬦᬾ,ᬤᬸᬭᬸᬲᬂᬓ᭄ᬮᬶᬓ᭄ᬤᭂᬭᬶᬓᬶ",
  textRegister: "ᬲᬫ᭄ᬧᬸᬦ᭄ᬫᬤᬸᬯᬾᬳᬓᬸᬦ᭄‌ᬤᬸᬭᬸᬲᬂᬗᭂᬭᬜ᭄ᬚᬶᬂ",
  errorPassword1: "ᬲᬦ᭄ᬤᬶᬧᬮᬶᬂᬓᬶᬤᬶᬓ᭄ᬦᭂᬫ᭄ᬤᬶᬚᬶᬢ᭄",
  errorPassword2: "ᬲᬦ᭄ᬤᬶᬫᬗ᭄ᬤᬧᬢᭂᬄ",
  //end Login & Register
  //change Password
  oldPassword:"",
  next:"",
  newPassword:"",
  send: "ᬲᬳᬸᬭᬶᬦ᭄",
  //options
  logout: "ᬫᭂᬤᬮ᭄",
  contributor: "ᬓᭀᬦ᭄ᬢ᭄ᬭᬶᬩᬸᬢᭀᬃ",
  changePassword: "ᬕᬦ᭄ᬢᬶᬲᬦ᭄ᬤᬶ",
  about: "ᬢᭂᬦ᭄ᬢᬂ",
  term: "ᬲ᭄ᬬᬭᬢ᭄ᬮᬦ᭄ᬓᭂᬢᭂᬦ᭄ᬢᬸᬯᬦ᭄",
  editProfile: "ᬳᬾᬤᬶᬢ᭄‌ᬧ᭄ᬭᭀᬧᬶᬮ᭄",
  viewProfile: "ᬘᬶᬗᬓ᭄‌ᬧ᭄ᬭᭀᬧᬶᬮ᭄",
  //home
  edit: "ᬳᬾᬤᬶᬢ᭄",
  _delete: "ᬳᬧᬸᬲ᭄",
  report: "ᬮᬧᭀᬭᬂ",
  nextPage:"ᬲᬦᬾᬮᬶᬬᬦᬦ᭄",
  lastPage:"ᬦᬾᬦ᭄ᬢᭂᬦ᭄‌ᬯᬾᬦ᭄ᬢᭂᬦ᭄ᬫᬮᬶᬄ",
  //edit profile
  regency: [
    { name: "ᬓᬭᬗᬲᭂᬫ᭄" },
    { name: "ᬓ᭄ᬮᬸᬗ᭄ᬓᬸᬂ" },
    { name: "ᬕ᭄ᬬᬜᬃ" },
    { name: "ᬩᬗ᭄ᬮᬶ" },
    { name: "ᬤᬾᬦ᭄ᬧᬲᬃ" },
    { name: "ᬩᬤᬸᬂ" },
    { name: "ᬢᬩᬦᬦ᭄" },
    { name: "ᬚᭂᬫ᭄ᬩ᭄ᬭᬦ" },
    { name: "ᬩᬸᬮᬾᬮᬾᬂ" },
  ],
  sex: [{ name: "ᬮᬦᬂ" }, { name: "ᬇᬲ᭄ᬢ᭄ᬭᬶ" }],
  whatsapp: "ᬦᭀᬫᭀᬃᬯᬢ᭄ᬲᬧ᭄",
};

export default constants;
